import { inflate } from 'pako';
import sanitizeHtml from 'sanitize-html';

export const pluralize = (count: number, singular: string, plural: string) =>
  count === 1 ? singular : plural;

export const decodeSliceDataBuffer = <T = unknown>(buffer: string) => {
  const binaryString = atob(buffer);
  const length = binaryString.length;
  const bytes = new Uint8Array(length);

  for (let i = 0; i < length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }

  const decompressedBytes = inflate(bytes);
  const jsonString = new TextDecoder('utf-8').decode(decompressedBytes);

  return JSON.parse(jsonString) as T;
};

export const formatDateString = (date: string) =>
  new Intl.DateTimeFormat('fr-FR', { dateStyle: 'short' }).format(
    new Date(date)
  );

export const stripHtml = (dirty: string): string =>
  sanitizeHtml(dirty, {
    allowedTags: [],
  }).trim();

export const randomId = () => {
  return Math.random().toString(36).slice(2) + Date.now().toString(36);
};
